import Dompurify from 'dompurify'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      methods: {
        /**
         * Sanitizes HTML content by removing potentially dangerous elements and attributes
         * @param {string} html - The HTML string to sanitize
         * @param {Object} [options={}] - Configuration options
         * @param {boolean} [options.removeStyles=true] - Whether to block style tags
         * @returns {string} Sanitized HTML string
         */
        $sanitizeHtml (html, options = {}) {
          const { removeStyles = true } = options
          const domPurifyConfig = { }
          if (removeStyles) {
            domPurifyConfig.FORBID_TAGS = ['style']
          }
          return Dompurify.sanitize(html, domPurifyConfig)
        },
      },
    })
  },
}
